import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsTable } from '../../shared/components/table/PsTable';
import ActiveLabel from '../../shared/components/ActiveLabel';
import DocumentSchemas from '../../shared/components/DocumentSchemas';
import RouterUtils from '../../shared/routing/RouterUtils';
import { CurrentUser } from '../../shared/model/CurrentUser';
import DocumentState from '../../shared/components/DocumentState';
import { PsMoreMenu } from '../../shared/components/more-menu/PsMoreMenu';
import { PsRoutes } from '../../shared/routing/Routes';

class MachinesTable extends React.Component {

    render() {
        const {
            data,
            error,
            currentUser,
            companyColumn,
        } = this.props;

        if ( !currentUser.hasRole() ) return null;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        if ( !data || data.length === 0 ) return null;

        const companyTR = companyColumn === 'outsource' ? 'TR_SUBCONTRATA' : 'TR_CONTRATISTA';

        return (
            <PsTable
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_ESTADO_DOCUMENTACION')}</th>
                        <th>{I18nUtils.tr('TR_MATRICULA')}</th>
                        <th>{I18nUtils.tr('TR_MARCA')}</th>
                        <th>{I18nUtils.tr('TR_MODELO')}</th>
                        <th>{I18nUtils.tr(companyTR)}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
                        <th />
                    </tr>
                )}
            >
                {
                    _.map(data, (machine) => {
                        const {
                            id,
                            machine_state,
                            name,
                            brand,
                            model,
                            document_schema,
                            contractors,
                            contractor,
                            company,
                            machine_documentation_state,
                            machine_contractor_state,
                        } = machine;

                        const companyName = companyColumn === 'outsource'
                            ? ( company ? company.name : '')
                            : ( contractor ? contractor.name : '');

                        const options = [
                            {
                                route: RouterUtils.generateRoute(
                                    PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL,
                                    { outsourceId: company.id, machineId: id },
                                ),
                                label: !currentUser.isOutsourcesViewer()
                                    ? I18nUtils.tr('TR_EDITAR')
                                    : I18nUtils.tr('TR_VER_FICHA'),
                            },
                        ];

                        const machineState = machine_contractor_state ? machine_contractor_state : machine_state;

                        return (
                            <tr key={id}>
                                <td><ActiveLabel state={machineState} /></td>
                                <td><DocumentState state={machine_documentation_state}/></td>
                                <td>{name}</td>
                                <td><strong>{brand}</strong></td>
                                <td><strong>{model}</strong></td>
                                <td>{companyName}</td>
                                <td>
                                    <DocumentSchemas
                                        currentUser={currentUser}
                                        contractors={contractors}
                                        documentSchema={document_schema}
                                        isOutsource={companyColumn === 'outsource'}
                                    />
                                </td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
            </PsTable>
        );
    }
}

const mapStateToProps = state => {
    return ( {
        currentUser: CurrentUser.fromReduxState(state),
    } );
};

export default connect(mapStateToProps)(MachinesTable);

MachinesTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
    companyColumn: PropTypes.oneOf('contractor', 'outsource'),
};

MachinesTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/machines/components/MachinesTable.jsx